// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: var(--spacing-large);
}

.flex-line {
  align-items: flex-start;
}
.flex-line.columns {
  gap: var(--spacing-largest);
}

p {
  font-size: var(--font-size-medium-large);
  line-height: var(--font-size-large);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/health-center/health-center-details/health-center-details.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,yBAAA;AACF;;AAEA;EACE,uBAAA;AACF;AACE;EACE,2BAAA;AACJ;;AAGA;EACE,wCAAA;EACA,mCAAA;AAAF","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: var(--spacing-large);\n}\n\n.flex-line {\n  align-items: flex-start;\n\n  &.columns {\n    gap: var(--spacing-largest);\n  }\n}\n\np {\n  font-size: var(--font-size-medium-large);\n  line-height: var(--font-size-large);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
